import { render, staticRenderFns } from "./summary-report-pension-fund-and-insurance.vue?vue&type=template&id=6f9a07b0&scoped=true&"
import script from "./summary-report-pension-fund-and-insurance.vue?vue&type=script&lang=js&"
export * from "./summary-report-pension-fund-and-insurance.vue?vue&type=script&lang=js&"
import style0 from "./summary-report-pension-fund-and-insurance.vue?vue&type=style&index=0&id=6f9a07b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9a07b0",
  null
  
)

export default component.exports